import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";

const TOKEN_COOKIE = "noohraToken";

export const decodeToken = (token) => {
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

export const IsTokenExpired = (token) => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) {
    return true;
  }
  return decoded.exp < Math.floor(Date.now() / 1000);
};

export const getToken = () => Cookies.get(TOKEN_COOKIE);

export const setToken = (token) => {
  Cookies.set(TOKEN_COOKIE, token, {
    sameSite: "lax",
    secure: window.location.protocol === "https:",
  });
};

export const clearToken = () => Cookies.remove(TOKEN_COOKIE);

/**
 * Returns the stored token if it is present and unexpired.
 * An expired token is removed so the rest of the app treats the user as logged out.
 */
export const getValidToken = () => {
  const token = getToken();
  if (!token) return null;
  if (IsTokenExpired(token)) {
    clearToken();
    return null;
  }
  return token;
};
